import { useEffect, useState, useCallback } from "react";
import { useApi } from "../containers/ApiContainer";
import { VipTagConfig } from "../types";
import { VipTagConfigService } from "../services/VipTagConfigService";

/**
 * Hook to fetch and manage VIP tags for an FBO
 */
export const useVipTags = (fboId: string | undefined) => {
  const { postgrest } = useApi();
  const [vipTags, setVipTags] = useState<VipTagConfig[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchTags = useCallback(async () => {
    if (!fboId || !postgrest) {
      setVipTags([]);
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);
      const service = new VipTagConfigService(postgrest);
      const data = await service.getVipTags(fboId);
      setVipTags(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to fetch VIP tags");
      console.error("Failed to fetch VIP tags:", err);
    } finally {
      setLoading(false);
    }
  }, [fboId, postgrest]);

  useEffect(() => {
    fetchTags();
  }, [fetchTags]);

  const refetch = useCallback(() => {
    fetchTags();
  }, [fetchTags]);

  return {
    vipTags,
    loading,
    error,
    refetch,
  };
};
